<div>
  {{ caseStatus.name }}
  <span *ngIf="progress && caseSubjects?.length > 1">({{ progress + '/' + caseSubjects.length }})</span>
</div>
<div>
  <span *ngIf="subjectsToShow?.length" class="comma-list">
    <span *ngFor="let subject of subjectsToShow">{{ subject | subjectName }}</span>
  </span>
</div>
